module.exports = __webpack_public_path__ + "static/img_1468-3fc1c7f6082c18640a7ce05044e6742c.jpg";